<template>
  <div class="container">
    <div class="top_title">
		<router-link class="icon_back" :to="{name: 'H050010', params:{searchInput:searchInput,I_LEVEL_CODE:I_LEVEL_CODE,I_FLAG:I_FLAG,tabFlag:tabFlag}}" tag="span"></router-link>
		<p>{{info.I_TITLE_1}}</p>
		<span style="float: right;position: absolute;top: 0;right: 0.6rem;">
		<span v-if="info.I_BUTTON_1!=''" style="background-color: #54C3f1;text-align: center;display: inline-block;border-radius: 15px;width: 3.4rem;height: 1.3rem;line-height: 1.3rem;color: #fff;font-size: 0.7rem;" @click="toH050030">{{info.I_BUTTON_1}}</span>
		</span>
		</div>
    <div class="main" style="overflow-y: auto;margin-top: 2.4rem;">
      <div class="top_pic"><img :src="info.I_SUMMARY_IMG" /></div>
      <p class="main_title"><span></span><span>{{info.I_LEVEL_NAME}}</span></p>
      <p class="main_contents">{{info.I_SUMMARY}}</p>
    </div>

    <router-link :to="{name: 'H050030', params:{id: info.I_BOOK_NO_SYS,I_PAGE_NO: '1',searchInput:searchInput,I_LEVEL_CODE:I_LEVEL_CODE,I_FLAG:I_FLAG,tabFlag:tabFlag}}" class="start_btn" tag="button">开始阅读</router-link>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'

  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: true,
          jchd: false,
          yyst: false,
          wd: false,
        },
        info: {
          I_BOOK_NO_SYS: "",
        },
        searchInput: '',  //上一页的搜索条件
        I_LEVEL_CODE: '', //上一页的搜索条件
        tabFlag: '', //上一页的搜索条件
        I_FLAG: '', //上一页的搜索条件
      }
    },
    components: {
      Footer
    },
    created() {
      this.info.I_BOOK_NO_SYS = this.$route.params.id
      this.searchInput = this.$route.params.searchInput
      this.I_LEVEL_CODE = this.$route.params.I_LEVEL_CODE
      this.tabFlag = this.$route.params.tabFlag
      this.I_FLAG = this.$route.params.I_FLAG
      if(this.info.I_BOOK_NO_SYS) {
        window.localStorage.setItem("H050020", this.info.I_BOOK_NO_SYS)
      } else {
        this.info.I_BOOK_NO_SYS = window.localStorage.getItem("H050020")
      }
      let params = {
        I_BOOK_NO_SYS: this.info.I_BOOK_NO_SYS
      }
      DataRequestFactory.I050020(params).then((response) => {
        this.info = response
      })
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 6
      $(".main").css("height", heightDiff + "px"   )
    },
	methods:{
		toH050030(){
			this.$router.push({name: 'H050040', params: {id: this.info.I_BOOK_NO_SYS,searchInput:this.searchInput,I_LEVEL_CODE:this.I_LEVEL_CODE,I_FLAG:this.I_FLAG,tabFlag:this.tabFlag}})
		}
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H050020.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H050020.vue